import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useEmptyStateStyles } from './EmptyState.styles';

type EmptyStateProps = {
  title: string;
  description: ReactNode;
  tall?: boolean;
  narrow?: boolean;
  showSearchIcon?: boolean;
};

const EmptyState = ({
  title,
  description,
  tall = false,
  narrow = false,
  showSearchIcon = true,
}: EmptyStateProps) => {
  const classes = useEmptyStateStyles();

  return (
    <div className={clsx(classes.emptyState, tall && classes.emptyStateTall)}>
      <div className={clsx(classes.emptyContent, narrow && classes.emptyContentNarrow)}>
        {showSearchIcon && <SearchIcon className={classes.emptyIcon} />}
        <h2 className={classes.emptyTitle}>{title}</h2>
        <p className={classes.emptyDescription}>{description}</p>
      </div>
    </div>
  );
};

export default EmptyState;
